// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-slide {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  align-items: center;\n}\n.swiper-tab-item {\n  flex: 1;\n}\n.swiper-slide > div {\n  max-width: 1200px;\n}\n.swiper-tab-bar-container {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n}\n.swiper-container {\n  width: 100%;\n  min-height: inherit;\n  flex: 1;\n  display: flex;\n}\n", ""]);
// Exports
module.exports = exports;
